import { colors } from '../../colors';
var para = {
  textColor: colors.onyx,
  messageColor: colors.onyx
};
export default para;